import React from 'react';
import RadioFieldGroup from 'components/shared/RadioFieldGroup/index';
import RadioField from 'components/shared/RadioFieldGroup/RadioField';

const SavedElementTypeSelection = ({ type, onChange }) => (
  <>
    <RadioFieldGroup
      className="ff-ss mt-12"
      selectedValue={type}
      name="type"
      onChange={onChange}
    >
      <RadioField className="c-p" value="SavedElementContents::Linked">
        <b className="c-brand-night">
          {t('saved_content.element_type.linked_element.title')}
        </b>
        <p className="fs-i mb-0 ml-24">
          {t('saved_content.element_type.linked_element.description')}
        </p>
      </RadioField>
      <RadioField className="c-p" value="SavedElementContents::Template">
        <b className="c-brand-night">
          {t('saved_content.element_type.template_element.title')}
        </b>
        <p className="fs-i mb-0 ml-24">
          {t('saved_content.element_type.template_element.description')}
        </p>
      </RadioField>
    </RadioFieldGroup>
  </>
);

export default SavedElementTypeSelection;
